// Founder Get Started quiz draft (pre-sign-in) → profile mapping.
// Used by Signup (new account: full write) and Login (existing account: fill
// empty fields only). Draft is cleared once the server has accepted it.
import { convertQuizCompletion } from "../components/quiz/ShareScore";

export const FOUNDER_QUIZ_STORAGE_KEY = "clinq_get_started_v2";

export function readFounderQuizDraft() {
  try {
    const raw = localStorage.getItem(FOUNDER_QUIZ_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}

export async function applyFounderQuizDraft(apiClient, { mergeOnlyEmpty = false } = {}) {
  const o = readFounderQuizDraft();
  if (!o || !o.stage) return false;
  const prof = o.isProfitable === true ? "yes"
    : o.isProfitable === false ? "no"
    : o.isProfitable === "unsure" ? "not_sure" : "";
  try {
    await apiClient.post("/companies/me/quiz-answers", {
      stage: o.stage || "",
      industry: o.industry || "",
      industry_other: o.industry === "other" ? (o.industryOther || "") : "",
      revenue_band: o.revenueBand || "",
      is_profitable: prof,
      docs: Array.isArray(o.docs) ? o.docs : [],
      capital_purposes: Array.isArray(o.purposes) ? o.purposes : [],
      capital_purpose_primary: o.primaryPurpose || "",
      capital_purpose_other: o.purposeOther || "",
      raise_amount_bracket: o.raiseBracket || "",
      preliminary_score: typeof o.preliminary_score === "number" ? o.preliminary_score : null,
      completed_at: o.completed_at || "",
      merge_only_empty: mergeOnlyEmpty,
    });
    try { localStorage.removeItem(FOUNDER_QUIZ_STORAGE_KEY); } catch { /* ignore */ }
    convertQuizCompletion(apiClient);
    return true;
  } catch (e) {
    if (process.env.NODE_ENV === "development") console.warn("[quiz draft] apply failed", e);
    return false;
  }
}
